import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/shijisun/edu/projects/imui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Message from './index';
import MessageItem from './lib/MessageItem';
import Button from '../button/index';
import './style/index.scss';
import { Playground, Props } from 'docz';
import LibMessage from './lib/Message.jsx';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "message"
    }}>{`Message`}</h1>

    <p>{`Message组件采用js调用的方式来使用，组件提供了六个常用静态方法，调用后返回的是该消息实例的关闭函数。`}</p>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={LibMessage} mdxType="Props" />
    <h3 {...{
      "id": "messageconfig全局配置参数"
    }}>{`Message.config全局配置参数`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`属性`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`说明`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`默认值`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`direction`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`消息的展现位置`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'top'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`duration`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`默认自动关闭延时，单位秒`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Number`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`zIndex`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`消息展示zIndex`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Number`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`4000`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h2>
    <Playground __position={1} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.handleInfo = this.handleInfo.bind(this)\n      this.handleSucess = this.handleSucess.bind(this)\n      this.handleAlert = this.handleAlert.bind(this)\n      this.handleQuestion = this.handleQuestion.bind(this)\n      this.handleLoading = this.handleLoading.bind(this)\n    }\n    handleInfo() {\n      Message.info(\'可以随便说说话\', { duration: 0 })\n    }\n    handleSucess() {\n      Message.success(\'恭喜你达成一个亿的小目标！\')\n    }\n    handleAlert() {\n      Message.alert(\'警告！你犯了错了！\')\n    }\n    handleQuestion() {\n      Message.question(\'小朋友你是否有很多问号？\')\n    }\n    handleLoading() {\n      let apis = Message.loading(\'loading, 自定义3s后关闭\')\n      setTimeout(() => {\n        apis.close()\n      }, 3000)\n    }\n    render() {\n      return (\n        <>\n          <Button onClick={this.handleInfo}> info </Button>\n          <Button onClick={this.handleSucess}>success</Button>\n          <Button onClick={this.handleAlert}>alert</Button>\n          <Button onClick={this.handleQuestion}>question</Button>\n          <Button onClick={this.handleLoading}>loading</Button>\n        </>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Message,
      MessageItem,
      Button,
      Playground,
      Props,
      LibMessage,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.handleInfo = this.handleInfo.bind(this);
            this.handleSucess = this.handleSucess.bind(this);
            this.handleAlert = this.handleAlert.bind(this);
            this.handleQuestion = this.handleQuestion.bind(this);
            this.handleLoading = this.handleLoading.bind(this);
          }

          handleInfo() {
            Message.info('可以随便说说话', {
              duration: 0
            });
          }

          handleSucess() {
            Message.success('恭喜你达成一个亿的小目标！');
          }

          handleAlert() {
            Message.alert('警告！你犯了错了！');
          }

          handleQuestion() {
            Message.question('小朋友你是否有很多问号？');
          }

          handleLoading() {
            let apis = Message.loading('loading, 自定义3s后关闭');
            setTimeout(() => {
              apis.close();
            }, 3000);
          }

          render() {
            return <>
            <Button onClick={this.handleInfo} mdxType="Button"> info </Button>
            <Button onClick={this.handleSucess} mdxType="Button">success</Button>
            <Button onClick={this.handleAlert} mdxType="Button">alert</Button>
            <Button onClick={this.handleQuestion} mdxType="Button">question</Button>
            <Button onClick={this.handleLoading} mdxType="Button">loading</Button>
            </>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "directions"
    }}>{`Directions`}</h2>
    <Playground __position={2} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.onClickLeft = this.onClickLeft.bind(this)\n      this.onClickRight = this.onClickRight.bind(this)\n      this.onClickBottom = this.onClickBottom.bind(this)\n      this.onClickTop = this.onClickTop.bind(this)\n      this.onClickCenter = this.onClickCenter.bind(this)\n    }\n    onClickLeft() {\n      Message.info({\n        content: \'左边方向消息\',\n        direction: \'left\',\n      })\n    }\n    onClickRight() {\n      Message.info({\n        content: \'右边方向消息\',\n        direction: \'right\',\n      })\n    }\n    onClickCenter() {\n      Message.info({\n        content: \'中间方向消息\',\n        direction: \'center\',\n      })\n    }\n    onClickTop() {\n      Message.info({\n        content: \'上边方向消息\',\n        direction: \'top\',\n      })\n    }\n    onClickBottom() {\n      Message.info({\n        content: \'底部方向消息\',\n        direction: \'bottom\',\n      })\n    }\n    render() {\n      return (\n        <>\n          <Button onClick={this.onClickTop}>Top</Button>\n          <Button onClick={this.onClickBottom}>Bottom</Button>\n          <Button onClick={this.onClickCenter}>Center</Button>\n          <Button onClick={this.onClickLeft}>Left</Button>\n          <Button onClick={this.onClickRight}>Right</Button>\n        </>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Message,
      MessageItem,
      Button,
      Playground,
      Props,
      LibMessage,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.onClickLeft = this.onClickLeft.bind(this);
            this.onClickRight = this.onClickRight.bind(this);
            this.onClickBottom = this.onClickBottom.bind(this);
            this.onClickTop = this.onClickTop.bind(this);
            this.onClickCenter = this.onClickCenter.bind(this);
          }

          onClickLeft() {
            Message.info({
              content: '左边方向消息',
              direction: 'left'
            });
          }

          onClickRight() {
            Message.info({
              content: '右边方向消息',
              direction: 'right'
            });
          }

          onClickCenter() {
            Message.info({
              content: '中间方向消息',
              direction: 'center'
            });
          }

          onClickTop() {
            Message.info({
              content: '上边方向消息',
              direction: 'top'
            });
          }

          onClickBottom() {
            Message.info({
              content: '底部方向消息',
              direction: 'bottom'
            });
          }

          render() {
            return <>
            <Button onClick={this.onClickTop} mdxType="Button">Top</Button>
            <Button onClick={this.onClickBottom} mdxType="Button">Bottom</Button>
            <Button onClick={this.onClickCenter} mdxType="Button">Center</Button>
            <Button onClick={this.onClickLeft} mdxType="Button">Left</Button>
            <Button onClick={this.onClickRight} mdxType="Button">Right</Button>
            </>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "duration"
    }}>{`Duration`}</h2>
    <Playground __position={3} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.handleClick = this.handleClick.bind(this)\n    }\n    handleClick() {\n      Message.info({\n        content: \'I can show up only in 5s\',\n        duration: 5,\n      })\n    }\n    render() {\n      return <Button onClick={this.handleClick}>duration</Button>\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Message,
      MessageItem,
      Button,
      Playground,
      Props,
      LibMessage,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.handleClick = this.handleClick.bind(this);
          }

          handleClick() {
            Message.info({
              content: 'I can show up only in 5s',
              duration: 5
            });
          }

          render() {
            return <Button onClick={this.handleClick} mdxType="Button">duration</Button>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "closable"
    }}>{`Closable`}</h2>
    <Playground __position={4} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.handleClick = this.handleClick.bind(this)\n    }\n    handleClick() {\n      Message.info({\n        content: \"Close me if you don\'t need me any more\",\n        duration: 10,\n        closable: true,\n      })\n    }\n    render() {\n      return <Button onClick={this.handleClick}>Closable</Button>\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Message,
      MessageItem,
      Button,
      Playground,
      Props,
      LibMessage,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.handleClick = this.handleClick.bind(this);
          }

          handleClick() {
            Message.info({
              content: 'Close me if you don\'t need me any more',
              duration: 10,
              closable: true
            });
          }

          render() {
            return <Button onClick={this.handleClick} mdxType="Button">Closable</Button>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "complex-content"
    }}>{`Complex content`}</h2>
    <Playground __position={5} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.handleClick = this.handleClick.bind(this)\n    }\n    handleClick() {\n      Message.info({\n        content: (\n          <>\n            {\' \'}\n            <p> This is a paragraph </p>\n            <ul>\n              <li>Course 1</li>\n              <li>Course 2</li>\n              <li>Course 3</li>\n            </ul>\n          </>\n        ),\n      })\n    }\n    render() {\n      return <Button onClick={this.handleClick}>Complex Content</Button>\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Message,
      MessageItem,
      Button,
      Playground,
      Props,
      LibMessage,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.handleClick = this.handleClick.bind(this);
          }

          handleClick() {
            Message.info({
              content: <> <p> This is a paragraph </p>
                        <ul>
                            <li>Course 1</li>
                            <li>Course 2</li>
                            <li>Course 3</li>
                        </ul>
                        </>
            });
          }

          render() {
            return <Button onClick={this.handleClick} mdxType="Button">Complex Content</Button>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "onclose"
    }}>{`onClose`}</h2>
    <Playground __position={6} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.handleClick = this.handleClick.bind(this)\n    }\n    handleClick() {\n      Message.info({\n        content: \'Why not close me now?!\',\n        duration: 10,\n        closable: true,\n        onClose: () => {\n          Message.success(\n            {\n              content: \'You have call the onClose successfully!\',\n            },\n            2000,\n          )\n        },\n      })\n    }\n    render() {\n      return <Button onClick={this.handleClick}>onClose</Button>\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Message,
      MessageItem,
      Button,
      Playground,
      Props,
      LibMessage,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.handleClick = this.handleClick.bind(this);
          }

          handleClick() {
            Message.info({
              content: 'Why not close me now?!',
              duration: 10,
              closable: true,
              onClose: () => {
                Message.success({
                  content: 'You have call the onClose successfully!'
                }, 2000);
              }
            });
          }

          render() {
            return <Button onClick={this.handleClick} mdxType="Button">onClose</Button>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "global-settings"
    }}>{`Global Settings`}</h2>
    <Playground __position={7} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.handleDestroy = this.handleDestroy.bind(this)\n      this.handleDirection = this.handleDirection.bind(this)\n      this.handleDuration = this.handleDuration.bind(this)\n    }\n    handleDestroy() {\n      Message.destroy()\n    }\n    handleDirection() {\n      Message.config({\n        direction: \'left\',\n      })\n    }\n    handleDuration() {\n      Message.config({\n        duration: 5,\n      })\n    }\n    render() {\n      return (\n        <>\n          <Button onClick={this.handleDestroy}>Global Destroy</Button>\n          <Button onClick={this.handleDirection}>Global Direction</Button>\n          <Button onClick={this.handleDuration}>Global Duration</Button>\n        </>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Message,
      MessageItem,
      Button,
      Playground,
      Props,
      LibMessage,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.handleDestroy = this.handleDestroy.bind(this);
            this.handleDirection = this.handleDirection.bind(this);
            this.handleDuration = this.handleDuration.bind(this);
          }

          handleDestroy() {
            Message.destroy();
          }

          handleDirection() {
            Message.config({
              direction: 'left'
            });
          }

          handleDuration() {
            Message.config({
              duration: 5
            });
          }

          render() {
            return <>
            <Button onClick={this.handleDestroy} mdxType="Button">Global Destroy</Button>
            <Button onClick={this.handleDirection} mdxType="Button">Global Direction</Button>
            <Button onClick={this.handleDuration} mdxType="Button">Global Duration</Button>
            </>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      